// r178 → r180 upgrade: this file was a 4300+ line copy of the r161-dev FBXLoader
// which imported from repo-local ../../src/constants.js / ../../src/loaders/*.
// Replaced with a thin shim that re-exports the official r180 addons build.
// See libs/three.js/examples/jsm/loaders/FBXLoader.js for the actual implementation.
export { FBXLoader } from '../../libs/three.js/examples/jsm/loaders/FBXLoader.js';
